<template>
  <!-- 综合查询 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-permission="'admin:waibill:add'"
          class="glo_btnItems glo_bgcMainColor"
          @click="addBtns"
          >新增</el-button
        >
        <el-button
          v-permission="'admin:waibill:add:copy'"
          class="glo_btnItems"
          @click="addBtnsCopy"
          >复制新增</el-button
        >
        <el-button
          v-permission="'admin:waibill:end'"
          class="glo_btnItems"
          @click="stopYd"
          >终止</el-button
        >
        <el-button
          v-permission="'admin:waibill:revoke'"
          class="glo_btnItems"
          @click="VoidWaybill"
          >作废</el-button
        >
        <el-button
          v-permission="'admin:waibill:del'"
          class="glo_btnItems"
          @click="delBtns()"
          >删除</el-button
        >
        <el-button
          v-permission="'admin:waibill:shen:he:guan:zhang'"
          class="glo_btnItems"
          @click="examineWaybill"
          >审核关账</el-button
        >
        <el-button
          v-permission="'admin:waibill:shen:he:guan:zhang:cancel'"
          class="glo_btnItems"
          @click="cancelExamineWaybill"
          >取消审核关账</el-button
        >
        <el-button
          v-permission="'admin:waibill:trace'"
          class="glo_btnItems"
          @click="genzongYD"
          >运单跟踪</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="caiwuLuRu()"
          v-permission="'admin:waibill:fee:checkin'"
          >费用录入</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="rukuqueren()"
          v-permission="'admin:waibill:ruku:confirm'"
          >入库确认</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="cancelrukuqueren()"
          v-permission="'admin:waibill:ruku:cancel'"
          >取消入库</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="qiantaishendan()"
          v-permission="'admin:waibill:shendan:confirm'"
          >前台审单</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="cancelqiantaishendan()"
          v-permission="'admin:waibill:shendan:cancel'"
          >取消审单</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="batchOutgoing()"
          v-permission="'admin:waibill:outgoing:batch'"
          >批量外发</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="cancelSignforWaybill()"
          v-permission="'admin:waibill:sign:cancel'"
          >取消签收</el-button
        >
        <el-button
            class="glo_btnItems"
            @click="releaseSure()"
            v-permission="'admin:waibill:sign:releaseSure'"
        >放货确认
        </el-button>
        <el-button
            class="glo_btnItems"
            @click="cancelReleaseSure()"
            v-permission="'admin:waibill:sign:cancelReleaseSure'"
        >取消放货确认
        </el-button>
        <!-- <el-button class="glo_btnItems glo_bgcMainColor" @click="printEvent()"
          >打印</el-button
        > -->
        <el-dropdown class="topDropDown" @command="printItNow">
          <el-button type="primary">
            打印
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="className.val"
              v-for="className in classNameArr"
              :key="className.val"
              >
              <div style="display: flex;">
                <span style="flex:1;padding-right:10px;">{{ className.name }}</span>
                <el-button type="text" @click.stop="printIt(className.val)">设置</el-button>
              </div>
              </el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-dropdown class="topDropDown" @command="handlePrint">
          <el-button type="primary">
            打印
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="qd">全打</el-dropdown-item>
            <el-dropdown-item command="td">套打</el-dropdown-item>
            <el-dropdown-item command="dybq">打印标签</el-dropdown-item>
            <el-dropdown-item command="dyhkpz">打印回扣凭证</el-dropdown-item>
            <el-dropdown-item command="dyxf">打印信封</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="printBtns">打印</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      @fildsClick="fildsClick"
      @handleCommandBtns="handleCommandBtns"
      @handleSelectionChange="handleSelectionChange"
    ></mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <myDialog
      diaWidth="1400px"
      dialogTitle="运单跟踪"
      :isShowDialog="isShowTraceDialog"
      :dialogFooter="false"
      @handleCloseDia="isShowTraceDialog = false"
      height-lock
      body-full
    >
      <el-container style="height: 100%">
        <el-header height="40px;" style="border-bottom: 1px solid #dcdfe6">
          <el-form
            class="diaForm"
            ref="dialogFormRef232"
            :model="dialogTraceForm"
            inline
          >
            <el-form-item
              class="dialogFormItems"
              prop="waybillNumber"
              label="运单号:"
              style="margin-bottom: 5px"
            >
              <el-input v-model="dialogTraceForm.waybillNumber"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 5px">
              <el-button
                class="glo_bgcMainColor"
                size="small"
                @click="getTraces"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </el-header>
        <el-container style="overflow: hidden; padding: 0px 0px 20px 20px">
          <el-aside
            width="45%"
            style="border-right: 1px solid #dcdfe6; padding: 10px"
          >
            <div class="rightInner">
              <el-timeline>
                <el-timeline-item
                  v-for="(item, index) in TrackList"
                  :key="index"
                  :timestamp="item.title"
                  placement="top"
                  :color="item.color"
                >
                  <el-card>
                    <div class="card_class">
                      <div class="line_cont">
                        <aside>{{ item.content }}</aside>
                        <div class="displayFlex">
                          <div v-if="item.expandFieldOne">
                            车牌号：{{ item.expandFieldOne || "" }}。
                          </div>
                          <div v-if="item.expandFieldTwo">
                            发出仓库：{{ item.expandFieldTwo || "" }}，
                          </div>
                          <div v-if="item.expandFieldThree">
                            目的地：{{ item.expandFieldThree || "" }}
                          </div>
                        </div>
                        <div class="trackImgsList">
                          <el-image
                            v-for="(itemA, idxA) in item.fileVoList"
                            :key="idxA"
                            class="trackImgs"
                            :src="itemA.fileUrl"
                            :preview-src-list="item.imgsList"
                          ></el-image>
                        </div>
                        <!-- <section>{{ item.createTime }}</section> -->
                        <section>{{ item.happenTime }}</section>
                      </div>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-aside>
          <el-main style="padding-left: 10px">
            <el-tabs v-model="dialogTraceForm.activeName" class="gen-zong-tab">
              <el-tab-pane label="跟踪录入" name="first">
                <el-form
                  label-position="right"
                  label-width="80px"
                  :model="dialogTraceForm.params"
                >
                  <el-form-item label="发生时间" prop="operationTime">
                    <el-date-picker
                      type="datetime"
                      v-model="dialogTraceForm.params.operationTime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :disabled="!dialogTraceForm.waybillSpiltId"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="跟踪信息" prop="content">
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="dialogTraceForm.params.content"
                      :disabled="!dialogTraceForm.waybillSpiltId"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="isShow">
                    <el-checkbox
                      v-model="dialogTraceForm.params.isShow"
                      :true-label="1"
                      :false-label="0"
                      :disabled="!dialogTraceForm.waybillSpiltId"
                      >显示在运单轨迹</el-checkbox
                    >
                  </el-form-item>
                  <el-form-item label="图片">
                    <uploadimgs
                      @input="changeTraceParamsFileList"
                      :fileNameLists="dialogTraceForm.params.fileNameTraceLists"
                      :limit="9"
                      :disabled="!dialogTraceForm.waybillSpiltId"
                    ></uploadimgs>
                  </el-form-item>
                  <el-form-item label="">
                    <el-button
                      class="glo_bgcMainColor"
                      size="small"
                      @click="saveKfTrack()"
                      :disabled="!dialogTraceForm.waybillSpiltId"
                      >保存录入</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="运单签收" name="second">
                <el-form
                  label-position="right"
                  label-width="80px"
                  :model="dialogTraceForm.sign"
                >
                  <el-form-item label="签收人" prop="signForName">
                    <el-input
                      v-model="dialogTraceForm.sign.signForName"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                    ></el-input>
                    <el-checkbox
                      v-model="dialogTraceForm.sign.isReceiveUserSign"
                      :true-label="1"
                      :false-label="0"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                      >收货人</el-checkbox
                    >
                  </el-form-item>
                  <el-form-item label="签收时间" prop="signForTime">
                    <el-date-picker
                      type="datetime"
                      v-model="dialogTraceForm.sign.signForTime"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="签收情况" prop="signForSituation">
                    <el-select
                      v-model="dialogTraceForm.sign.signForSituation"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                    >
                      <el-option
                        v-for="(item, index) in signForSituationList"
                        :key="index"
                        :label="item.showName"
                        :value="item.statusVal"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注" prop="remarks">
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="dialogTraceForm.sign.remarks"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="签收图片" prop="signForFileIds">
                    <my-image-upload
                      :readonly="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                      @input="changeTraceSignFileList"
                      :fileNameLists="dialogTraceForm.sign.fileNameTraceLists"
                    ></my-image-upload>
                  </el-form-item>
                  <el-form-item label="">
                    <el-checkbox
                      v-model="dialogTraceForm.sign.isSenderSms"
                      :true-label="1"
                      :false-label="0"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                      >发送手机信息给发货人</el-checkbox
                    >
                    <el-checkbox
                      v-model="dialogTraceForm.sign.isReceiverSms"
                      :true-label="1"
                      :false-label="0"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                      >发送手机信息给收货人</el-checkbox
                    >
                    <el-checkbox
                      v-model="dialogTraceForm.sign.isRnOrderSure"
                      :true-label="1"
                      :false-label="0"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                      >回单收回确认</el-checkbox
                    >
                  </el-form-item>
                  <template
                    v-if="
                      !dialogTraceForm.signed &&
                      dialogTraceForm.sign.isRnOrderSure
                    "
                  >
                    <el-form-item
                      label="收回部门:"
                      prop="returnDeptId"
                      style="width: 100%"
                    >
                      <el-select
                        filterable
                        clearable
                        v-model="dialogTraceForm.sign.returnDeptId"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item, index) in businessDepts"
                          :key="index"
                          :label="item.deptName"
                          :value="item.deptId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="收回人:"
                      prop="returnUserId	"
                      style="width: 100%"
                    >
                      <el-select
                        filterable
                        clearable
                        v-model="dialogTraceForm.sign.returnUserId"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item, index) in EmployeeList"
                          :key="index"
                          :label="item.name"
                          :value="item.documentId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="回单图片" prop="rnOrderFileIds">
                      <my-image-upload
                        :readonly="
                          !dialogTraceForm.waybillSpiltId ||
                          dialogTraceForm.signed
                        "
                        @input="changeTraceSignRnFileList"
                        :fileNameLists="
                          dialogTraceForm.sign.fileNameRnTraceLists
                        "
                      ></my-image-upload>
                    </el-form-item>
                  </template>
                  <el-form-item label="">
                    <el-button
                      class="glo_bgcMainColor"
                      size="small"
                      @click="saveSign"
                      :disabled="
                        !dialogTraceForm.waybillSpiltId ||
                        dialogTraceForm.signed
                      "
                      >保存录入</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="签单上传" name="third">
                <el-form label-position="right" label-width="80px">
                  <el-form-item label="签收图片">
                    <my-image-upload
                      :readonly="!dialogTraceForm.signed"
                      @input="changeTraceSignItFileList"
                      :fileNameLists="dialogTraceForm.signIt.fileNameTraceLists"
                    ></my-image-upload>
                  </el-form-item>
                  <el-form-item label="">
                    <el-button
                      class="glo_bgcMainColor"
                      size="small"
                      @click="saveSignIt"
                      :disabled="!dialogTraceForm.signed"
                      >保存</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-main>
        </el-container>
      </el-container>
    </myDialog>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item class="dialogFormItems" prop="aaa" label=":">
            <el-input v-model="dialogForm.aaa"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="bbb" label="活动区域:">
            <el-select v-model="dialogForm.bbb" placeholder="请选择">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="ccc" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.ccc"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 修改运单号 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef2')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog2"
          ref="dialogFormRef2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="waybillNumber"
            label="修改运单号:"
          >
            <el-input v-model="dialogForm2.waybillNumber"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 签收图片 -->
    <myDialog
      :diaWidth="diaWidth6"
      :dialogTitle="dialogTitle6"
      :isShowDialog="isShowDialog6"
      @handleCloseDia="handleCloseDia6"
      @diaCancelBtn="handleCloseDia6"
      @diaConfirmBtn="diaConfirmBtn6('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog6"
          ref="dialogFormRef"
          label-width="100px"
        >
          <el-form-item label="签收图片:" style="width: 100%">
            <uploadimgs
              @input="changeFileList6"
              :fileNameLists="fileNameLists6"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      :getApiType.sync="getApiType"
      modelTypeVal="运单打印模板"
      ref="myPrint"
      :dataSource="printDataSource"
      :add-permission="printPermission"
      :edit-permission="printPermission"
      :del-permission="printPermission"
    ></my-print>
    <my-dialog
      diaWidth="500px"
      dialogTitle="确认把所选数据操作入库确认？"
      :isShowDialog="isShowDialog7"
      @handleCloseDia="handleCloseDia7"
      @diaCancelBtn="handleCloseDia7"
      @diaConfirmBtn="diaConfirmBtn7('dialogFormRef')"
    >
      <el-form
        class="diaForm"
        v-if="isShowDialog7"
        ref="dialogFormRef"
        label-width="100px"
      >
        <el-form-item label="加入库存网点" prop="storageId">
          <!-- <el-select v-model="rukuFormData.storageId" filterable>
            <el-option
              v-for="dept in businessDepts"
              :key="dept.deptId"
              :label="dept.deptName"
              :value="dept.deptId"
            ></el-option>
          </el-select> -->
          <dept-tree
            v-model="rukuFormData.storageId"
            :multiple="false"
            :is-storage="1"
            :checkStrictly="true"
            :fullInput="false"
          ></dept-tree>
        </el-form-item>
        <!-- <el-form-item label="加入库存类型" prop="stockType">
          <el-select v-model="rukuFormData.stockType" filterable style="width:100%;">
            <el-option label="到货库存" value="dao_huo:stock_type"></el-option>
            <el-option label="发货库存" value="fa_huo:stock_type"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
    </my-dialog>
    <my-dialog
      diaWidth="400px"
      dialogTitle="确认把所选数据操作外发？"
      :isShowDialog="isShowDialog8"
      @handleCloseDia="handleCloseDia8"
      @diaCancelBtn="handleCloseDia8"
      @diaConfirmBtn="diaConfirmBtn8('dialogFormRef')"
    >
      <el-form
        class="diaForm"
        v-if="isShowDialog8"
        ref="dialogFormRef"
        label-width="100px"
      >
        <el-form-item label="外发承运商: " prop="carrierId">
          <el-select
            v-model="batchOutgoingFormData.carrierId"
            filterable
            remote
            :remote-method="getCarriers"
            @focus="getCarriers()"
          >
            <el-option
              v-for="carrier in carriers"
              :key="carrier.carrierId"
              :label="carrier.carrierName"
              :value="carrier.carrierId"
            ></el-option>
          </el-select>
          <!-- <dept-tree v-model="batchOutgoingFormData.storageId" checkStrictly :multiple="false" :full-input="false"></dept-tree> -->
        </el-form-item>
      </el-form>
    </my-dialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import mytable from "@/components/table/VrTable.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
// import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import colorStatus from "@/assets/js/Mixins/colorStatus.js"; //导出的公共js
import MyImageUpload from "@/components/MyImageUpload.vue";
import MyPrint from "@/components/print/MyPrint.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew, exportjs, colorStatus],
  components: {
    queryCondition,
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
    mytable,
    MyImageUpload,
    MyPrint,
  },
  data() {
    return {
      // ==== 弹窗组件属性 start ====
      isShowDialog6: false,
      dialogTitle6: "签收图片",
      diaWidth6: "80%",
      rnorderId6: "",
      fileNameLists6: [], //上传组件的
      // ==== 弹窗组件属性 end ====
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "运单列表",
        //apiName: "/admin/v4/tms/waybill/getWaybillList", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        pageType: "ComprehensiveQuery", //页面类型(主要用来区分查询参参数的时间)
      },
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "WaybillEdit", //当前页面的方法
          param: 1, //自定义参数标记
          permission: "admin:waibill:edit",
        },
        // {
        //   name: "删除",
        //   methods: "delBtns",
        //   param: "",
        // },
        {
          name: "详情",
          methods: "detail",
          param: 2,
          permission: "admin:waibill:detail",
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "修改运单号",
          command: "updateNumber",
          permission: "admin:waibill:edit:order:num",
        },
        {
          name: "修改基本信息",
          command: "updateInfo",
          permission: "admin:waibill:edit:order:base",
        },
      ],
      //需要单独点击的列字段名数组
      fieldList: ["commandNumber"],
      Operatewidth: "220px", //操作列的列宽
      //=======================导出相关 结束 =======================
      waybillStatusList: [], //运单状态
      OnwayStatusList: [], //在途状态
      OutgoingStatusList: [], //外发状态
      storageList: [], //网点列表
      CarrierLists: [], //承运商列表
      //  -----  查询  ------
      queryData: {
        currentDeptId: "",
        customerNumber: "",
        customereOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        fieldName: "",
        fieldVal: "",
        onwayStatus: "",
        outboundCarrierId: "",
        outgoingStatus: "",
        startBusinessTime: "",
        startCreateTime: "",
        waybillNumber: "",
        waybillStatus: "",
        carrierName: "",
        businessDeptId: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
        {
          value: "2",
          label: "提货日期",
        },
        {
          value: "3",
          label: "交货日期",
        },
      ],
      timeType: "2", //  时间类型
      startTime_a: "",
      endTime_a: "",

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度
      // totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "ComprehensiveQuery", //  页面标识
      reportFiledsNumber: "admin_waybill_list_v5", // 动态 条件、表头
      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: "修改运单号",
      diaWidth2: "40%",
      dialogForm2: { waybillNumber: "", waybillSplitId: "" },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },

      CustomerLists: [],

      aaaa: [
        {
          className: "calssName1",
          val: "接口1",
        },
        {
          className: "calssName2",
          val: "接口2",
        },
      ], // 模板className 问后台拿

      // 打印插件 每个页面不一样的
      idarrs: [],
      classNameArr: [
        // {
        //   name: "全打",
        //   val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillQdPrintDataV5VO",
        // },
        // {
        //   name: "套打",
        //   val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillTdPrintDataV5VO",
        // },
        // {
        //   name: "标签打印",
        //   val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillBqPrintDataV5VO",
        // },
        {
          name: "套打",
          val: "print_tao_da_waybill_data",
        },
        {
          name: "全打",
          val: "print_quan_da_waybill_data",
        },
        {
          name: "标签打印",
          val: "print_waybill_table_data",
        },
        {
          name: "回扣打印",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO",
        },
        {
          name: "信封打印",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillXfPrintDataV5VO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillTdPrintDataV5VO",
      getApiTypeA: false,
      businessDeptIdArr: [],
      // 运单跟踪弹窗
      isShowTraceDialog: false,
      dialogTraceForm: {
        waybillNumber: "",
        activeName: "first",
        params: {
          isShow: 0,
          fileNameTraceLists: [],
        },
        sign: {
          signForTime: this.$TOOLS.getCurrentTime(),
          fileNameTraceLists: [],
          fileNameRnTraceLists: [],
        },
        signIt: {
          fileNameTraceLists: [],
        },
      },
      fileNameTraceLists: [],
      TrackList: [],
      signForSituationList: [],
      isShowDialog7: false,
      rukuFormData: {},
      depts: [],
      isShowDialog8: false,
      batchOutgoingFormData: {},
      carriers: [],
    };
  },
  updated() {},
  created() {
    this.GetDept();
    this.getSignSituation();
    this.getBusinessDepts();
    this.getObjectUserDownList("employee");
  },
  mounted() {},
  activated() {},

  watch: {},
  methods: {
    async getCarriers(carrierName) {
      const number = "down_list_carrier";
      const res = await this.$API.runList({
        number,
        carrierName,
      });
      this.carriers = res;
    },
    printPermission(action) {
      let scope = "";
      switch (this.modelClassName) {
        case "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillQdPrintDataV5VO":
          scope = "qd";
          break;
        case "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillTdPrintDataV5VO":
          scope = "td";
          break;
        case "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillBqPrintDataV5VO":
          scope = "bq";
          break;
        case "print_waybill_table_data":
          scope = "bq";
          break;
        case "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO":
          scope = "hk";
          break;
        case "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillXfPrintDataV5VO":
          scope = "xf";
          break;
        case "print_quan_da_waybill_data":
          scope = "bq"; // 全打权限还没加,用标签的
          break;
        case "print_tao_da_waybill_data":
          scope = "bq"; // 权限还没加,用标签的
          break;
        default:
          scope = "common";
          break;
      }
      console.log(scope);
      return "admin:waybill:print:" + action + ":" + scope;
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    handleCommandBtns(command, data) {
      this[command](data);
    },

    updateNumber({ waybillSplitId, waybillNumber }) {
      this.dialogForm2 = { waybillSplitId, waybillNumber };
      this.isShowDialog2 = true;
    },
    updateInfo(row) {
      this.$router.push({
        path: "/WaybillManage/WaybillBaseEditRX",
        query: {
          waybillSplitId: row.waybillSplitId,
        },
      });
    },
    // 点击指定列
    fildsClick(data, field) {
      if (field == "commandNumber") {
        this.addModifyBtns(data, 2);
      }
    },
    // 选择图片
    changeFileList6(array) {
      this.fileNameLists6 = array;
    },
    // 获取业务网点（组织架构列表）
    GetDept() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.businessDeptIdArr = result;
        }
      });
    },
    rukuqueren() {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择至少一条运单进行操作");
        return false;
      }
      this.isShowDialog7 = true;
    },
    cancelrukuqueren() {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择至少一条运单进行操作");
        return false;
      }
      this.$confirm("确认把所选数据操作取消入库确认")
        .then(() => {
          this.$API
            .inStockCancel({
              waybillSplitIds: this.selectTableData.map(
                (item) => item.waybillSplitId
              ),
            })
            .then((res) => {
              this.$message.success("操作成功");
            });
        })
        .catch((err) => {});
    },
    qiantaishendan() {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择至少一条运单进行操作");
        return false;
      }
      this.$confirm("确认把所选数据操作审单确认")
        .then(() => {
          this.$API
            .approval({
              waybillSplitIds: this.selectTableData.map(
                (item) => item.waybillSplitId
              ),
            })
            .then((res) => {
              this.$message.success("操作成功");
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancelqiantaishendan() {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择至少一条运单进行操作");
        return false;
      }
      this.$confirm("确认把所选数据操作取消审单确认")
        .then(() => {
          this.$API
            .cancelApproval({
              waybillSplitIds: this.selectTableData.map(
                (item) => item.waybillSplitId
              ),
            })
            .then((res) => {
              this.$message.success("操作成功");
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // // *************************打印模板 start *************************
    // handleCloseClassNameDia() {
    //   this.isShowClassNameDialog = false;
    // },
    // classNameDiaCancelBtn() {
    //   this.isShowClassNameDialog = false;
    // },
    // classNameDiaConfirmBtn() {
    //   // modelClassName
    //   if (!this.modelClassName) {
    //     this.$message.error("请选择className");
    //     return;
    //   }
    //   this.isShowClassNameDialog = false;
    //   setTimeout(() => {
    //     this.dialogFrom.dialogVisible = false;
    //     this.printTitle = "创建模板";
    //     this.printType = 1;
    //     this.modelObj = null;
    //     setTimeout(() => {
    //       this.printForm.dialogVisible = true;
    //     }, 300);
    //   }, 300);
    // },
    // // 打印系统关闭
    // handlePrintSysClose() {
    //   if (this.$refs.dialogSelect) {
    //     this.$refs.dialogSelect.doSearch();
    //   }
    // },
    // // 打印弹出框创建
    // handleCreated() {
    //   this.isShowClassNameDialog = true;
    // },
    // // 打印预览模板
    // handleEdit(obj) {
    //   // this.dialogFrom.dialogVisible = false;
    //   this.printTitle = obj.modelName;
    //   this.printType = 2;
    //   this.modelObj = obj;
    //   setTimeout(() => {
    //     this.printForm.dialogVisible = true;
    //   }, 300);
    // },
    // // 打印预览模板
    // handleView(obj) {
    //   console.log("obj", obj);
    //   let hiprintTemplate = new hiprint.PrintTemplate({
    //     template: JSON.parse(obj.content),
    //   });
    //   let idarr = [];
    //   for (let i = 0; i < this.selectTableData.length; i++) {
    //     idarr.push(this.selectTableData[i].waybillSplitId);
    //   }
    //   if (obj.className == this.modelClassName) {
    //     this.$API
    //       .getWaybillRxPrintData({
    //         waybillSplitIds: idarr,
    //       })
    //       .then((res) => {
    //         if (res.status == 200) {
    //           if (res.data && res.data.status == "success") {
    //             const result = res.data.result;
    //             hiprintTemplate.print(result, {});
    //           }
    //         }
    //       });
    //   }
    // },

    // // 打印
    // printEvent(row) {
    //   if (this.selectTableData.length < 1) {
    //     this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
    //       confirmButtonText: "新建模板",
    //       cancelButtonText: "关闭",
    //     }).then((res) => {
    //       if (res == "confirm") {
    //         this.handleCreated();
    //       } else {
    //         // this.$message.error("请选择需要打印的数据源");
    //         // return false;
    //       }
    //     });
    //   } else {
    //     let idarr = this.selectTableData.map((item) => {
    //       return item.waybillSplitId;
    //     });
    //     window.sessionStorage.setItem(
    //       "set_PrintSelectTableData",
    //       JSON.stringify(idarr)
    //     );
    //     this.dialogFrom.dialogVisible = true;
    //   }
    // },

    // // 打印相关的
    // handleCloseDia_print() {
    //   this.isShowDialog_print = false;
    // },
    // // 打印预览确定
    // diaConfirmBtn_print() {
    //   this.isShowDialog_print = false;
    // },
    // 打印相关的
    // *************************打印模板 end *************************

    printConditions(rows) {
      return {
        sliptId: rows.map((item) => item.waybillSpiltId),
      };
    },
    printDataSource(rows) {
      if (
        this.modelClassName ===
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO"
      ) {
        return new Promise((resolve, reject) => {
          this.$API
            .hkPrintData({
              waybillSplitIds: rows.map((d) => d.waybillSplitId),
            })
            .then((res) => {
              const result = res.data.result;
              resolve(result);
            })
            .catch((err) => {});
        });
      } else {
        
      }
      if (this.modelClassName === "print_waybill_table_data") {
        return new Promise((resolve, reject) => {
          this.$API
            .runList({
              number: "print_waybill_table_data",
              waybillSplitIds: rows.map((d) => d.waybillSplitId),
            })
            .then((res) => {
              const result = res;
              // 标签需要按照件数来打印
              const datas = []
              for(let i=0;i<res.length;i++){
                let ddd = res[i]
                let total = ddd.totalCount || 1
                for(let j=0;j<total;j++){
                  datas.push(ddd)
                }
              }
              resolve(datas);
            })
            .catch((err) => {});
        });
      }

      // // 全打
      // if (this.modelClassName === "print_quan_da_waybill_data") {
      //   return new Promise((resolve, reject) => {
      //     this.$API
      //       .runList({
      //         number: "print_quan_da_waybill_data",
      //         waybillSplitIds: rows.map((d) => d.waybillSplitId),
      //       })
      //       .then((res) => {
      //         const result = res;
      //         resolve(result);
      //       })
      //       .catch((err) => {});
      //   });
      // }
      // // 套打
      // if (this.modelClassName === "print_tao_da_waybill_data") {
      //   return new Promise((resolve, reject) => {
      //     this.$API
      //       .runList({
      //         number: "print_tao_da_waybill_data",
      //         waybillSplitIds: rows.map((d) => d.waybillSplitId),
      //       })
      //       .then((res) => {
      //         const result = res;
      //         resolve(result);
      //       })
      //       .catch((err) => {});
      //   });
      // }
      return new Promise((resolve, reject) => {
          this.$API
            .runList({
              number: this.modelClassName,
              waybillSplitIds: rows.map((d) => d.waybillSplitId),
            })
            .then((res) => {
              const result = res;
              resolve(result);
            })
            .catch((err) => {});
      });
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },

    // 选择承运商
    changeCarrier(e) {
      if (e) {
        this.CarrierLists.forEach((item) => {
          if (item.carrierName == e) {
            this.queryData.outboundCarrierId = item.carrierId;
          }
        });
      } else {
        this.queryData.outboundCarrierId = "";
        this.getCarrierList();
      }
      if (!this.isShowDialog_dc) {
        this.queryBtn_ok();
      }
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 获取运单状态
    getWaybillStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.waybill_status")
        .then((res) => {
          this.waybillStatusList = res || [];
        });
    },
    // 获取在途状态
    getOnwayStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.onway_status")
        .then((res) => {
          this.OnwayStatusList = res || [];
        });
    },
    // 外发状态
    getOutgoingStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.outgoing_status")
        .then((res) => {
          this.OutgoingStatusList = res || [];
        });
    },
    // 获取客户列表
    getCustomerList(number) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: number,
          number: "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择客户触发
    changeCustomerNumber(e) {
      if (!e) {
        this.getCustomerList();
      }
      this.queryBtn_ok();
    },
    // async glo_getStatusValList(val) {
    //   let resData = "";
    //   await this.$API
    //     .getStatusValList({ tableAndFieldName: val })
    //     .then((res) => {
    //       resData = res.data.result || [];
    //     });

    //   return resData;
    // },
    //  作废运单
    VoidWaybill() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择至少一条运单进行操作");
        return false;
      }
      this.$confirm("是否作废所选运单？请谨慎操作", "提示：")
        .then(() => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.waybillSplitId);
          });
          this.$API
            .wtl_cancelWaybill({
              waybillSplitIds: ids,
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch(() => {});
    },
    // 取消签收
    cancelSignforWaybill(row) {
      let ids = [];
      if (row) {
        ids = [row.waybillSplitId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择至少一条运单进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }

      this.$confirm("是否取消签收所选运单？请谨慎操作", "提示：")
        .then(() => {
          this.$API
            .cancelSignforWaybill({
              waybillSplitIds: ids,
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch(() => {});
    },
    //  xxx
    chaiDan(row) {
      this.$router.push({
        path: "/WaybillManage/SplitOrder",
        query: {
          waybillSplitId: row.waybillSplitId,
          waybillNumber: row.waybillNumber,
        },
      });
    },
    // 新增
    addBtns() {
      this.$router.push({
        path: "/WaybillManage/WaybillCreateRX",
        query: {
          pageType: "isreload",
        },
      });
    },
    // 费用录入
    caiwuLuRu(row) {
      let id = "";
      if (row) {
        id = row.waybillSplitId;
      } else {
        if (this.selectTableData.length !== 1) {
          this.$message.error("请选择一条运单进行操作");
          return false;
        }
        id = this.selectTableData[0].waybillSplitId;
      }
      this.$router.push({
        path: "/WaybillManage/WaybillFeeCheckInRX",
        query: {
          waybillSplitId: id,
        },
      });
    },
    // 修改运单
    WaybillEdit(row) {
      //
      this.$router.push({
        path: "/WaybillManage/WaybillEditRX",
        query: {
          waybillSplitId: row.waybillSplitId,
        },
      });
    },
    detail(row) {
      this.$router.push({
        path: "/WaybillManage/sumAll/ComprehensiveQuerySumAll",
        query: {
          waybillNumber: row.waybillNumber,
        },
      });
    },
    // 运输规划
    transportPlan(row) {
      this.$router.push({
        path: "/WaybillManage/TransportationPlann",
        query: {
          waybillNumber: row.waybillNumber,
          waybillSplitId: row.waybillSplitId,
        },
      });
    },
    // 删除运单
    delBtns(val) {
      // 右边单选
      let ids = [];
      let wayNum = "";
      if (val && val.waybillSplitId) {
        ids = [val.waybillSplitId];
        wayNum = val.waybillNumber;
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }
      this.$confirm("确定要删除所选运单" + wayNum + "吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.wtl_delWaybill({ waybillSplitIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
    // 复制新增
    addBtnsCopy() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条运单进行操作");
        return false;
      }

      let datas = this.selectTableData[0];

      this.$router.push({
        path: "/WaybillManage/WaybillCopyRX",
        query: {
          waybillSplitId: datas.waybillSplitId,
        },
      });
    },
    // 签收
    qianShouhBtns() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择一条运单进行签收");
        return false;
      }
      this.$router.push({
        path: "/WaybillManage/WaybillSigne",
        query: {
          datas: JSON.stringify(this.selectTableData),
        },
      });
    },
    // 过账
    guoZhang(row) {
      // if (this.selectTableData.length !== 1) {
      //   this.$message.warning("请选择一条运单过账");
      //   return false;
      // }
      this.$router.push({
        // path: "/WaybillManage/Posting",
        path: "/WaybillManage/WaybillEditRX",
        query: {
          waybillSplitId: row.waybillSplitId,
          // waybillNumber: row.waybillNumber,
        },
      });
    },
    // 反过账
    fanGuoZhang() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择一条运单进行操作");
        return false;
      }
      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.waybillSplitId);
      });
      this.$confirm(
        "确认对所选的运单进行反过账操作吗? 请谨慎操作!",
        "提示"
      ).then(() => {
        this.$API
          .wtl_postingBackWaybill({ waybillSplitIds: ids })
          .then((res) => {
            this.$message.success(res.data.message || "");
            this.getData();
          });
      });
    },
    // 终止运单
    stopYd() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择一条运单进行操作");
        return false;
      }
      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.waybillSplitId);
      });
      this.$confirm("确认终止所选的运单吗? 请谨慎操作!", "提示").then(() => {
        this.$API.wtl_stopWaybill({ waybillSplitIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getData();
        });
      });
    },
    // 合单
    heDan() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择 1 条主运单进行合单操作");
        return false;
      }

      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.waybillSplitId);
      });
      this.$confirm("确认把所选的运单进行合单吗? 请谨慎操作!", "提示").then(
        () => {
          this.$API.wtl_closeWaybill({ waybillSplitIds: ids }).then((res) => {
            this.$message.success(res.data.message || "");
            this.getData();
          });
        }
      );
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2.waybillNumber = "";
      this.dialogForm2.waybillSpiltId = "";
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定要修改运单号吗？请谨慎操作", "提示")
            .then(() => {
              this.updateWaybillNumber();
            })
            .catch(() => {});
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },

    // 上传回单图片
    upLoadImgsBtns(row) {
      this.isShowDialog6 = true;
      this.rnorderId6 = row.waybillSplitId;
      this.$API
        .getWaybillSignforInfo({
          waybillSplitId: this.rnorderId6,
        })
        .then((res) => {
          if (res.data.status == "success") {
            let { fileList = [] } = res.data.result?.[0] || {};
            if (fileList.length) {
              this.fileNameLists6 = fileList.map((item) => {
                return {
                  name: item.fileId,
                  url: item.fileUrl,
                };
              });
            }
          }
        });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia6() {
      this.isShowDialog6 = false;
      this.fileNameLists6 = [];
      this.rnorderId6 = "";
    },
    handleCloseDia7() {
      this.isShowDialog7 = false;
      this.rukuFormData = {};
    },
    handleCloseDia8() {
      this.isShowDialog8 = false;
      this.batchOutgoingFormData = {};
    },
    //  弹窗确认保存事件
    diaConfirmBtn6(formName) {
      this.$API
        .updateSignforWaybillFile({
          fileIds: this.fileNameLists6.map((item) => {
            return {
              fileId: item.name,
              fileName: item.name,
            };
          }),
          waybillSplitId: this.rnorderId6,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog6 = false;
          this.$TOOLS.resetForm(this, formName);
          this.getData();
        });
    },
    diaConfirmBtn7(formName) {
      this.$API
        .inStockSure({
          waybillSplitIds: this.selectTableData.map(
            (item) => item.waybillSplitId
          ),
          currentDeptId: this.rukuFormData.storageId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog7 = false;
        });
    },
    diaConfirmBtn8(formName) {
      const waybillSplitIds = this.selectTableData.map(
        (item) => item.waybillSplitId
      );
      this.$API
        .batchAddOutgoing({
          waybillSplitIds,
          carrierId: this.batchOutgoingFormData.carrierId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog8 = false;
        });
    },
    batchOutgoing() {
      if (this.selectTableData.length === 0) {
        this.$message.error("请选择需要批量外发的运单");
        return;
      }
      this.isShowDialog8 = true;
    },
    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },
    examineWaybill() {
      if (this.selectTableData.length > 0) {
        this.$confirm("确定要审核关账运单？")
          .then(() => {
            this.$API
              .examineWaybill({
                waybillSplitIds: this.selectTableData.map(
                  (item) => item.waybillSplitId
                ),
                examineStatus: "yi_shen_he:examine_status",
              })
              .then((res) => {
                this.$message.success(res.data.message || "审核关账成功");
                this.getData();
              });
          })
          .catch(() => {});
      } else {
        this.$message.error("请选择需要审核关账的运单");
      }
    },
    cancelExamineWaybill() {
      if (this.selectTableData.length > 0) {
        this.$confirm("确定要取消审核关账运单？")
          .then(() => {
            this.$API
              .examineWaybill({
                waybillSplitIds: this.selectTableData.map(
                  (item) => item.waybillSplitId
                ),
                examineStatus: "wei_shen_he:examine_status",
              })
              .then((res) => {
                this.$message.success(res.data.message || "取消审核关账成功");
                this.getData();
              });
          })
          .catch(() => {});
      } else {
        this.$message.error("请选择需要取消审核关账的运单");
      }
    },
    // 客户跟踪
    genzongBtns() {
      let str = "";
      console.log(this.selectTableData);
      this.selectTableData.forEach((item) => {
        str += item.waybillNumber + ",";
      });
      if (str.length > 0) {
        str = str.substring(0, str.length - 1);
      }
      this.documentNumbers = str;
      this.documentStatus = "bill_tms_waybill_split_v3:document_status"; //tms运单单据
      this.showDia1 = true;
    },
    genzongYD(row) {
      if (this.selectTableData.length === 1) {
        this.dialogTraceForm.waybillNumber =
          this.selectTableData[0].waybillNumber;
        this.getTraces();
      }
      this.isShowTraceDialog = true;
    },
    // 修改运单号
    updateWaybillNumber() {
      this.$API
        .wtl_updateWaybillNumber({
          waybillNumber: this.dialogForm2.waybillNumber,
          waybillSpiltId: this.dialogForm2.waybillSplitId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "修改成功");
          this.isShowDialog2 = false;
          this.getData();
        });
    },
    changeTraceParamsFileList(files) {
      this.dialogTraceForm.params.fileNameTraceLists = files;
    },
    changeTraceSignFileList(files) {
      this.dialogTraceForm.sign.fileNameTraceLists = files;
    },
    changeTraceSignRnFileList(files) {
      this.dialogTraceForm.sign.fileNameRnTraceLists = files;
    },
    changeTraceSignItFileList(files) {
      this.dialogTraceForm.signIt.fileNameTraceLists = files;
    },
    handlePrint(command) {
      this.printEvent();
    },
    getTraces() {
      this.$API
        .getTrackTransportListV5({
          waybillNumber: this.dialogTraceForm.waybillNumber,
          documentStatus: "bill_tms_waybill_split_v3:document_status",
        })
        .then((res) => {
          let arrs = res.data.result || [];
          let TrackList = arrs.reverse(); //翻转数组
          TrackList.forEach((item, index) => {
            item.isShow = item.isShow == 1 ? true : false;
            item.color = "";
            if (index == 0) {
              item.color = "#0bbd87";
            }
            item.imgsList = [];
            if (item.fileVoList && item.fileVoList.length > 0) {
              item.fileVoList.forEach((itemA) => {
                item.imgsList.push(itemA.fileUrl);
              });
            }
          });

          this.TrackList = TrackList;
          if (this.TrackList.length > 0) {
            this.dialogTraceForm.waybillSplitNumber =
              this.TrackList[0].waybillSplitNumber;
            this.dialogTraceForm.waybillSpiltId =
              this.TrackList[0].waybillSplitId;
            this.dialogTraceForm.signed = this.TrackList[0].signed;
            if (this.dialogTraceForm.signed) {
              this.getWaybillSignforInfo();
            }
          }
        });
    },
    getSignSituation() {
      // 获取签收情况下拉列表
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_sign_for_v3.sign_for_situation")
        .then((res) => {
          this.signForSituationList = res || [];
        });
    },
    async getWaybillSignforInfo() {
      const res = await this.$API.getWaybillSignforInfo({
        waybillSplitId: this.dialogTraceForm.waybillSpiltId,
      });
      const signInfo = res.data.result[0];
      const fileNameTraceLists = signInfo.fileList;
      this.dialogTraceForm.sign = {
        ...signInfo,
        fileNameTraceLists,
      };
    },
    async saveKfTrack() {
      this.$API
        .addBillKfTrackRecordV2({
          ...this.dialogTraceForm.params,
          documentNumber: [this.dialogTraceForm.waybillSplitNumber],
          documentStatus: "bill_tms_waybill_split_v3:document_status",
          fileIds: this.dialogTraceForm.params.fileNameTraceLists.map(
            (item) => item.name
          ),
        })
        .then((res) => {
          this.$message.success(res.data.message || "提交成功");
          this.dialogTraceForm.params = {
            fileNameTraceLists: [],
            isShow: 0,
          };
          this.getTraces();
        });
    },
    saveSign() {
      this.$API
        .signforWaybill({
          ...this.dialogTraceForm.sign,
          waybillSpiltIds: [this.dialogTraceForm.waybillSpiltId],
          signForFileIds: this.dialogTraceForm.sign.fileNameTraceLists,
          rnOrderFileIds: this.dialogTraceForm.sign.fileNameRnTraceLists,
        })
        .then((res) => {
          this.$message.success(res.data.message || "签收成功");
          this.getTraces();
        });
    },
    saveSignIt() {
      this.$API
        .updateSignforWaybillFile({
          waybillSplitId: this.dialogTraceForm.waybillSpiltId,
          fileIds: this.dialogTraceForm.signIt.fileNameTraceLists,
        })
        .then((res) => {
          this.$message.success(res.data.message || "修改成功");
          this.getTraces();
        });
    },
    printIt(command) {
      this.modelClassName = command;

      switch (command) {
        case "print_waybill_table_data":
          this.getApiType = true;
          break;
        case "print_quan_da_waybill_data":
          this.getApiType = true;
          break;
        case "print_tao_da_waybill_data":
          this.getApiType = true;
          break;
        default:
          this.getApiType = false;
          break;
      }
      
      this.$nextTick(() => {
        this.printSetting();
      })
    },
    printItNow(command) {
      console.log(command)
      this.modelClassName = command;

      switch (command) {
        case "print_waybill_table_data":
          this.getApiType = true;
          break;
        case "print_quan_da_waybill_data":
          this.getApiType = true;
          break;
        case "print_tao_da_waybill_data":
          this.getApiType = true;
          break;
        default:
          this.getApiType = false;
          break;
      }
      this.$nextTick(() => {
        this.printEventNow();
      })
    },

    //放货确认
    releaseSure(row) {
      let ids = [];
      if (row) {
        ids = [row.waybillSplitId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择至少一条运单进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }

      this.$confirm("是否放货确认所选运单？请谨慎操作", "提示：")
          .then(() => {
            this.$API
                .releaseSure({
                  waybillSplitIds: ids,
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
          })
          .catch(() => {});
    },

    //取消放货确认
    cancelReleaseSure(row) {
      let ids = [];
      if (row) {
        ids = [row.waybillSplitId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择至少一条运单进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }

      this.$confirm("是否取消放货确认所选运单？请谨慎操作", "提示：")
          .then(() => {
            this.$API
                .cancelReleaseSure({
                  waybillSplitIds: ids,
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
          })
          .catch(() => {});
    },
  },
};
</script>


<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

// .iconInput {
//   display: flex;
//   align-items: center;
// }
// .mainCOlorBtns {
//   background-color: #f0a261;
//   color: #fff;
//   border: none;
// }
// .mainCOlorBtns :hover {
//   color: #fff;
// }

// .greenClass {
//   background-color: #aee7be !important;
//   color: #f00;
// // }
// .CaoZuo {
//   /deep/ .cell {
//     padding-right: 0 !important;
//   }
// }
.actionColumn {
  background-color: #f5f7fa !important; /* 设置背景颜色 */
  color: #ffffff; /* 设置文本颜色 */
  font-size: 14px; /* 设置字体大小 */
  z-index: 999;
  height: 34px;
  line-height: 34px;
  width: 220px;

  .moreBtns {
    // padding: 0;
    height: 24px;
    line-height: 24px;
  }
}

.bottomPages {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .colorTips {
    display: flex;
    align-items: center;

    .tipsItem {
      margin-right: 10px;
      color: #000;
      font-size: 14px;
      padding: 4px 10px;
      border-radius: 20px;
    }
  }
}
.gen-zong-tab {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  /deep/ .el-tabs__content {
    flex: 1;
    overflow: auto;
    padding: 10px 10px 10px 10px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
}
.rightInner {
  flex: 1;
  cursor: pointer;
  overflow-y: auto;
  //border: 1px solid #ddd;
  //padding: 10px;
  flex: 1;
  /deep/ .el-tabs__item {
    height: 36px;
    line-height: 36px;
    background-color: #f4f4f4;
  }

  /deep/ .el-tabs__content {
    padding: 16px;
  }

  /deep/ .el-descriptions {
    margin-bottom: 10px;
  }
  /deep/.el-timeline-item__timestamp {
    font-size: 16px;
    color: #333;
  }
  .line_cont {
    color: #888;
  }
  .tit_top {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    color: #333;
    font-size: 14px;
    span {
      flex: 1;
    }
  }
}
.trackImgsList {
  display: flex;

  .trackImgs {
    width: 60px;
    height: 60px;
    margin: 10px;
  }
}
</style>
